<template lang="pug">
  div(
    v-if="hasData"
    class="insights-members-location-popover"
  )
    div.d-flex.flex-column
      template(v-if="columnData.time_remote || columnData.time_on_site")
        span Remote: {{ formatToHm(columnData.time_remote) }} ({{ calculatePercentage('remote') }}%)
        span Office: {{ formatToHm(columnData.time_on_site) }} ({{ calculatePercentage('on_site') }}%)
      template(v-else)
        span Remote: {{ parseMemberPercentage('remote') }}% ({{ displayMemberCount('remote') }}) 
        span Office: {{ parseMemberPercentage('on_site') }}% ({{ displayMemberCount('on_site') }})
</template>

<script>
import { secondsToHours } from '~/utils/time_utils';

export default {
  name: 'InsightsMembersLocationPopover',
  props: {
    columnData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    hasData() {
      return this.columnData && 'value' in this.columnData;
    },
  },
  methods: {
    displayMemberCount(column) {
      const memberWord = this.parseMemberCount(column) === 1 ? 'member' : 'members';

      return `${this.parseMemberCount(column)} ${memberWord}`;
    },
    calculatePercentage(column) {
      const total = this.columnData.time_remote + this.columnData.time_on_site;

      if (total === 0) {
        return 0;
      }

      return ((this.columnData[`time_${column}`] / total) * 100).toFixed(0);
    },
    parseMemberCount(column) {
      return this.columnData[column]?.count || 0;
    },
    parseMemberPercentage(column) {
      const total = this.parseMemberCount('remote') + this.parseMemberCount('on_site');

      if (total === 0) {
        return 0;
      }

      return ((this.parseMemberCount(column) / total) * 100).toFixed(0);
    },
    formatToHm(seconds) {
      const [h, m] = secondsToHours(seconds).split(':');

      return `${h}h ${m}m`;
    },
  },
};
</script>
